const mathMLTags = [
  'math',
  'mrow',
  'mi',
  'mo',
  'mn',
  'ms',
  'mtext',
  'mspace',
  'msqrt',
  'mroot',
  'mfrac',
  'msub',
  'msup',
  'msubsup',
  'munder',
  'mover',
  'munderover',
  'mtable',
  'mtr',
  'mtd',
  'mfenced',
  'menclose',
  'maction',
  'mpadded',
  'mphantom',
  'merror',
  'semantics',
  'annotation',
];

export const config = {
  $$identifier: {
    allowedTags: [],
    allowedAttributes: {},
  },
  title: {
    allowedTags: ['br', 'a', 'sub', 'sup', 'span', ...mathMLTags],
    allowedAttributes: {
      a: ['href', 'rel', 'root', 'target'],
      span: ['class', 'data-href', 'data-rel'],
      math: ['xmlns', 'display'],
    },
    transformTags: {
      p: 'br',
      i: 'em',
      b: 'strong',
    },
  },
  description: {
    allowedTags: [
      'b',
      'i',
      'em',
      'strong',
      'br',
      'ol',
      'ul',
      'li',
      'a',
      'table',
      'tr',
      'td',
      'tbody',
      'thead',
      'th',
      'hr',
      'sub',
      'sup',
      'span',
      ...mathMLTags,
    ],
    allowedAttributes: {
      a: ['href', 'rel', 'root', 'target'],
      table: ['style', 'border'],
      td: ['colspan', 'rowspan', 'style'],
      span: ['class', 'data-href', 'data-rel'],
      math: ['xmlns', 'display'],
    },
    transformTags: {
      p: 'br',
      i: 'em',
      b: 'strong',
    },
  },
  shortdescription: {
    allowedTags: [
      'b',
      'i',
      'em',
      'strong',
      'br',
      'ol',
      'ul',
      'li',
      'a',
      'table',
      'tr',
      'td',
      'tbody',
      'thead',
      'th',
      'hr',
      'sub',
      'sup',
      'span',
      ...mathMLTags,
    ],
    allowedAttributes: {
      a: ['href', 'rel', 'root', 'target'],
      table: ['style', 'border'],
      td: ['colspan', 'rowspan', 'style'],
      span: ['class'],
      math: ['xmlns', 'display'],
    },
    transformTags: {
      p: 'br',
      i: 'em',
      b: 'strong',
    },
  },
  html: {
    allowedTags: [
      'b',
      'i',
      'em',
      'strong',
      'br',
      'ol',
      'ul',
      'li',
      'a',
      'img',
      'table',
      'tbody',
      'tr',
      'td',
      'sub',
      'sup',
      'span',
      ...mathMLTags,
    ],
    allowedAttributes: {
      a: ['href', 'rel', 'root', 'title', 'identifier', 'target'],
      table: ['style', 'border'],
      td: ['colspan', 'rowspan', 'style'],
      span: ['class', 'data-href', 'data-rel'],
      math: ['xmlns', 'display'],
    },
    transformTags: {
      i: 'em',
      b: 'strong',
      p: 'br',
    },
  },
  clearAll: {
    allowedTags: [],
    allowedAttributes: {},
  },
};
